if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.modalPrevButton = this.querySelector('[id^="ModalPrev-"]');
        this.modalNextButton = this.querySelector('[id^="ModalNext-"]');

        if (this.modalPrevButton) this.modalPrevButton.addEventListener('click', this.showPreviousMedia.bind(this));
        if (this.modalNextButton) this.modalNextButton.addEventListener('click', this.showNextMedia.bind(this));

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'ArrowLeft') {
            event.preventDefault();
            this.showPreviousMedia();
          } else if (event.code === 'ArrowRight') {
            event.preventDefault();
            this.showNextMedia();
          }
        });

        this.touchStartX = 0;
        this.touchEndX = 0;
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
          container.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        this.showActiveMedia(opener.getAttribute('data-media-id'));
        this.toggleNavButtons();
      }

      toggleNavButtons() {
        const hideNav = !this.mediaItems || this.mediaItems.length <= 1;
        if (this.modalPrevButton) this.modalPrevButton.hidden = hideNav;
        if (this.modalNextButton) this.modalNextButton.hidden = hideNav;
      }

      getActiveMediaId() {
        const activeMedia = this.querySelector('[data-media-id].active');
        return activeMedia ? activeMedia.getAttribute('data-media-id') : null;
      }

      showPreviousMedia() {
        this.stepMedia(-1);
      }

      showNextMedia() {
        this.stepMedia(1);
      }

      stepMedia(direction) {
        if (!this.mediaItems || this.mediaItems.length <= 1) return;
        const activeMediaId = this.getActiveMediaId();
        const currentIndex = this.mediaItems.findIndex(
          (item) => item.getAttribute('data-media-id') === activeMediaId
        );
        const newIndex = (currentIndex + direction + this.mediaItems.length) % this.mediaItems.length;
        const newMediaId = this.mediaItems[newIndex].getAttribute('data-media-id');
        this.showActiveMedia(newMediaId);
      }

      handleTouchStart(event) {
        this.touchStartX = event.changedTouches[0].screenX;
      }

      handleTouchEnd(event) {
        this.touchEndX = event.changedTouches[0].screenX;
        const swipeThreshold = 40;
        const difference = this.touchStartX - this.touchEndX;

        if (Math.abs(difference) < swipeThreshold) return;

        if (difference > 0) {
          this.showNextMedia();
        } else {
          this.showPreviousMedia();
        }
      }

      showActiveMedia(mediaId) {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
